var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 70,
    viewBox: "0 0 50 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9990",
    "data-name": "Group 9990",
    transform: "translate(-608 -826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9989",
    "data-name": "Group 9989",
    transform: "translate(623 847)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "PDF",
    transform: "translate(10 26)",
    fill: "#8e8e8e",
    fontSize: 10,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.025em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.998,
    y: 0
  }, "PDF")), /*#__PURE__*/React.createElement("path", {
    id: "add-3",
    d: "M8.824,3.81H6.19V1.176a1.191,1.191,0,0,0-2.381,0V3.81H1.176a1.191,1.191,0,0,0,0,2.381H3.81V8.824a1.191,1.191,0,0,0,2.381,0V6.19H8.824a1.191,1.191,0,0,0,0-2.381Z",
    transform: "translate(5)",
    fill: "#8e8e8e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4537",
    "data-name": "Rectangle 4537",
    transform: "translate(608 826)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    strokeDasharray: "2 3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 70,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 49.5,
    height: 69.5,
    rx: 9.75,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCv);
export default __webpack_public_path__ + "static/media/cv.74a7fcebeb7320539fce25f18661a316.svg";
export { ForwardRef as ReactComponent };